import './Footer.css';
import { Link } from 'react-router';
import { FaInstagram } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import { URI } from '../../Utils/api';

export default function Footer () {
    const [healthStatus, setHealthStatus] = useState({ status: 'checking', database: 'unknown' });

    useEffect(() => {
        const checkHealth = async () => {
            try {
                // Extract base URL from API URI (e.g., https://api.hydromastery.com/api -> https://api.hydromastery.com)
                const urlObj = new URL(URI);
                const healthUrl = `${urlObj.origin}/health`;

                const response = await fetch(healthUrl, {
                    method: 'GET',
                    credentials: 'include'
                });

                if (response.ok) {
                    const data = await response.json();
                    setHealthStatus({
                        status: data.status === 'ok' ? 'healthy' : 'unhealthy',
                        database: data.database || 'unknown'
                    });
                } else {
                    setHealthStatus({ status: 'unhealthy', database: 'unknown' });
                }
            } catch (error) {
                setHealthStatus({ status: 'unhealthy', database: 'unknown' });
            }
        };

        checkHealth();
        // Check health every 30 seconds
        const interval = setInterval(checkHealth, 30000);
        return () => clearInterval(interval);
    }, []);

    const getHealthStatusText = () => {
        if (healthStatus.status === 'healthy') return 'All Systems Operational';
        if (healthStatus.status === 'unhealthy') return 'Service Unavailable';
        return 'Checking Status...';
    };

    return (
        <footer id='footer'>
            <div className='footer-inner'>
                <div className='footer-grid'>
                    <div className='footer-info'>
                        <h3>HydroMastery</h3>
                        <p className='footer-tagline'>
                            Swimming performance and coaching, built on the swimmer&apos;s own test results.
                        </p>
                        <address>
                            Athens, Greece
                            <br />
                            Edinburgh, Scotland
                            <br />
                            <strong>Email:</strong> hydromastery@gmail.com
                        </address>
                        <div className='social-links'>
                            <a href='https://www.instagram.com/hydromastery/' target='_blank' rel='noopener noreferrer' aria-label='Instagram'>
                                <FaInstagram aria-hidden='true' />
                            </a>
                            <a href='https://www.tiktok.com/@hydromastery' target='_blank' rel='noopener noreferrer' aria-label='TikTok'>
                                <FaTiktok aria-hidden='true' />
                            </a>
                            <a href='https://www.youtube.com/@hydromastery26' target='_blank' rel='noopener noreferrer' aria-label='YouTube'>
                                <FaYoutube aria-hidden='true' />
                            </a>
                        </div>
                    </div>

                    <div className='footer-links'>
                        <h4>On this page</h4>
                        <ul>
                            <li><a href='/#hero'>Home</a></li>
                            <li><a href='/#about'>About</a></li>
                            <li><a href='/#services'>Features</a></li>
                            <li><a href='/#pricing'>Pricing</a></li>
                            <li><a href='/#contact'>Contact</a></li>
                        </ul>
                    </div>

                    <div className='footer-links'>
                        <h4>How it works</h4>
                        <ul>
                            <li><a href='/#zones'>Training zones</a></li>
                            <li><a href='/#programs'>Programs</a></li>
                            <li><a href='/#groups'>Groups and attendance</a></li>
                            <li><a href='/#race'>Race analysis</a></li>
                        </ul>
                    </div>

                    <div className='footer-links'>
                        <h4>Account and legal</h4>
                        <ul>
                            <li><Link to='/login'>Log in or sign up</Link></li>
                            <li><Link to='/terms-of-use'>Terms of service</Link></li>
                            <li><Link to='/privacy-policy'>Privacy policy</Link></li>
                        </ul>
                        <div className='health-check' role='status'>
                            <span
                                className={`health-dot health-${healthStatus.status}`}
                                aria-hidden='true'
                            ></span>
                            <span>{getHealthStatusText()}</span>
                            {healthStatus.status === 'healthy' && (
                                <span className='health-db'>Database: {healthStatus.database}</span>
                            )}
                        </div>
                    </div>
                </div>

                <div className='copyright'>
                    &copy; <strong>HydroMastery 2026</strong>. All rights reserved.
                </div>
            </div>
        </footer>
    );
}
